import styled from 'styled-components';

export const PartnershipSection = styled.section`
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
`;
